import { validateEmail } from '@/lib/validate';
import * as yup from 'yup';

export interface LoginFormValues {
  email: string;
  password: string;
}

/** Yup schema for sign-in: valid email format and non-empty password. */
export function createLoginSchema(t: (key: string) => string) {
  return yup.object({
    email: yup
      .string()
      .required(() => t('signup_required_email'))
      .test('email', function (value) {
        const result = validateEmail(value ?? '');
        if (result === true) return true;
        return this.createError({ message: result });
      }),
    password: yup.string().required(() => t('signup_required_password')),
  });
}
